import { type PropsWithChildren, type TextareaHTMLAttributes, useId } from 'react'

import { State } from '#/global/component/Form/State'
import type { DefaultProps } from '#/global/component/Form/types'

import { Input as Helper } from '#/global/helper/DekForms/Input'

export interface Props extends DefaultProps, Omit<TextareaHTMLAttributes<HTMLTextAreaElement>, 'size' | 'onChange'> {
    lazy?: boolean
    onChange?: (v: string) => void
}

export const Textarea = ({
    children,
    className,
    lazy,
    onChange,
    size,
    state,
    useSizeOnState,
    ...props
}: PropsWithChildren<Props>) => {
    const { disabled } = props
    const id = useId()

    const handleChange = (event: React.ChangeEvent<HTMLTextAreaElement>) => void onChange?.(event.target.value)

    const formWidth = Helper.getFormSize(size)

    const classNameList = [formWidth]
    state && classNameList.push(state.level)
    className && classNameList.push(className)

    return (
        <>
            {children !== undefined && <label htmlFor={id}>{children}</label>}
            <textarea
                className={classNameList.join(' ')}
                id={id}
                onBlur={lazy ? handleChange : undefined}
                onChange={lazy ? undefined : handleChange}
                role="textarea"
                {...props}>
            </textarea>
            {state && !disabled && state.message && <State formWidth={useSizeOnState === true ? formWidth : undefined} state={state} />}
        </>
    )
}
